<div class="input-group mb-3">
  <div class="col">
    {{ header }} <span *ngIf="keyRequired">*</span>
    <textarea
      class="form-control"
      rows="3"
      [placeholder]="placeholder"
      [ngClass]="{
        'error-border': showRequiredError || showPatternError
      }"
      [value]="value"
      (input)="onInputChange($event)"
      (blur)="onSubmitValue($event)"
    ></textarea>

    <!-- Required error -->
    <div *ngIf="showRequiredError" class="text-danger">
      This field is required.
    </div>

    <!-- Pattern error -->
    <div *ngIf="showPatternError" class="text-danger">
      Value does not match the required format.
    </div>
  </div>
</div>
